/**
 * Whether the session-chrome exit (the top-right X in ControlButtons) must ask
 * for the booth PIN before it ends the session.
 *
 * The X is the operator's way out, but on custom paths it is drawn at 10%
 * opacity and at ~0.5% once the booth is locked, so a guest can tap it without
 * knowing what it is; its only guard used to be a yes/no confirm. Once the
 * guest has paid, ending the session throws that payment away, so it takes the
 * PIN. Before payment nothing is lost and the confirm is enough. A booth with
 * no PIN set has nothing to check against and keeps the confirm.
 */
export function exitNeedsPin(
  transactionStatus: string | null | undefined,
  password: string | null | undefined
): boolean {
  return transactionStatus === 'settlement' && Boolean(password)
}
